function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m466.916 27.803h-421.832c-24.859 0-45.084 20.225-45.084 45.084v366.226c0 24.859 20.225 45.084 45.084 45.084h421.832c24.859 0 45.084-20.225 45.084-45.084v-366.226c0-24.859-20.225-45.084-45.084-45.084z",
  fill: "#f0f9ff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m198.58 188.334-181.344-150.862c-7.75 6.107-13.456 14.691-15.905 24.554l164.142 136.551h33.102z",
  fill: "#f40055"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m313.425 198.576h33.93l163.447-135.973c-2.325-9.923-7.93-18.592-15.613-24.796l-181.764 151.211z",
  fill: "#c20044"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m165.472 313.425-164.141 136.549c2.449 9.863 8.155 18.447 15.905 24.553l181.344-150.861-.005-10.241z",
  fill: "#f40055"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m313.425 313.425v9.557l181.765 151.211c7.683-6.204 13.288-14.874 15.613-24.796l-163.446-135.971z",
  fill: "#c20044"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m53.273 27.803 145.302 120.879v-120.879z",
  fill: "#406bd4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m313.425 150.571v-122.768h148.082z",
  fill: "#3257b0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m394.732 198.575 117.268-97.556v97.556z",
  fill: "#3257b0"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#406bd4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0 99.317v99.258h119.313z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 313.425v97.699l117.44-97.699z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m50.49 484.197 148.085-122.676v122.676z"
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m313.425 484.197v-124.139l149.221 124.139z",
  fill: "#3257b0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m512 409.423-115.395-95.998h115.395z",
  fill: "#3257b0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m512 222.142h-222.142v-194.339h-67.716v194.339h-222.142v67.716h222.142v194.339h67.716v-194.339h222.142z",
  fill: "#f40055"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m289.858 222.142v-194.339h-33.858v456.394h33.858v-194.339h222.142v-67.716z",
  fill: "#c20044"
});

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.9e6dbfb0.svg";
export { ForwardRef as ReactComponent };